const TournamentRecords = () => {
    const records = [
      { tournament: "Smash Cup 2025", place: "1st" },
      { tournament: "Melee Open", place: "2nd" },
    ];
  
    return (
    <div className="py-4 px-8">
          <h2 className="text-2xl font-bold pb-4 mb-4 text-center border-b border-gray-700">Tournament Records</h2>
          Coming soon...
    </div>
    );
  };
  
  export default TournamentRecords;